import React from 'react';
import classes from './Button.css';

const button = (props) => (
    <button
        id={props.id}
        className={[classes.Button, classes[props.btnType]].join(' ')}
        onClick={props.clicked}
        disabled={props.disabled}
        tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        {...props.attr}>
        {props.children}
    </button>
);

export default button;